import React from 'react';
import { Download } from 'lucide-react';
import { Button } from './button';
import { exportRowsToCSV, exportRowsToExcel, exportRowsToPdfPrint } from '../../lib/tableExport';

export const TableExportActions = ({ rows = [], columns = [], fileName = 'table-export', title = 'Table Export', className = '' }) => {
  const exportCsv = () => {
    exportRowsToCSV({ rows, columns, fileName: fileName.endsWith('.csv') ? fileName : `${fileName}.csv` });
  };

  const exportExcel = () => {
    exportRowsToExcel({ rows, columns, fileName: fileName.endsWith('.xls') ? fileName : `${fileName}.xls` });
  };

  const exportPdf = () => {
    exportRowsToPdfPrint({ rows, columns, title });
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Button size="sm" variant="outline" onClick={exportCsv}>
        <Download className="h-3.5 w-3.5 mr-1" />
        CSV
      </Button>
      <Button size="sm" variant="outline" onClick={exportExcel}>
        <Download className="h-3.5 w-3.5 mr-1" />
        Excel
      </Button>
      <Button size="sm" variant="outline" onClick={exportPdf}>
        <Download className="h-3.5 w-3.5 mr-1" />
        PDF
      </Button>
    </div>
  );
};

